// src/components/BlackHoleBackground/constants.js
export const BLACK_HOLE_RADIUS = 0.3;
export const DISK_INNER_RADIUS = BLACK_HOLE_RADIUS + 0.1;
export const DISK_OUTER_RADIUS = 8.5;
export const DISK_TILT_ANGLE = Math.PI / 3.1;